import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
const VSL_EMBED_URL = 'https://embed.fliki.ai/embed/6aa1bd3e5fd38b4876c6cec3';
export function VslPlayer() {
  const [playerLoaded, setPlayerLoaded] = useState(false);
  return <motion.figure initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative mx-auto mt-8 w-full max-w-[54rem] sm:mt-12" data-id="element-260" data-mp="yxqmxd1lxtu5">
      <div className="mb-3 flex items-center gap-3" data-id="element-261" data-mp="1mnktjcvc2m5y">
        <span className="flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-262" data-mp="1hprnqkxxzu67">
          <span aria-hidden="true" className="h-1.5 w-1.5 animate-blip rounded-full bg-signal-pink shadow-[0_0_8px_#ff2f92]" data-id="element-263" data-mp="1cqyamtmki56k" />
          Cinta de video · Prueba B
        </span>
        <span aria-hidden="true" className="h-px flex-1 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.14)_0_6px,transparent_6px_12px)]" data-id="element-264" data-mp="1azy2fs6l10l" />
        <span className="hidden font-mono text-[9.5px] uppercase tracking-[0.16em] text-white/30 sm:block" data-id="element-265" data-mp="1pufuz40lur60">
          Reproducción autorizada
        </span>
      </div>

      <div aria-hidden="true" className="absolute inset-x-8 top-16 -z-10 hidden h-40 rounded-full bg-[radial-gradient(ellipse,rgba(212,175,55,0.22),transparent_70%)] blur-3xl sm:block" data-id="element-266" data-mp="1fx1r03vvbuul" />

      <div className="relative rounded-xl border border-gold/25 bg-panel-raised p-2.5 shadow-[0_26px_60px_rgba(0,0,0,0.6)] sm:p-3" data-id="element-267" data-mp="16x4wvmqpm3s5">
        <div className="relative w-full overflow-hidden rounded-lg bg-black pt-[56.25%]" data-id="element-268" data-mp="s9jwi0l7yinx">
          {playerLoaded ? <iframe src={`${VSL_EMBED_URL}?autoplay=1`} title="Video de presentación — The Visual Disruption Bible 2.0" loading="lazy" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen className="absolute inset-0 h-full w-full border-0" data-id="element-269" data-mp="x4z80lvr82h6" /> : <button type="button" onClick={() => setPlayerLoaded(true)} aria-label="Reproducir el video de presentación" className="group absolute inset-0 flex flex-col items-center justify-center gap-4 bg-[radial-gradient(ellipse_at_50%_40%,rgba(212,175,55,0.14),transparent_65%),linear-gradient(180deg,#101014,#07070a)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-270" data-mp="2l2rivw8g82lc">
              <span aria-hidden="true" className="absolute inset-0 bg-[repeating-linear-gradient(0deg,rgba(255,255,255,0.03)_0_1px,transparent_1px_4px)]" data-id="element-271" data-mp="2yv7nv2kwuaow" />
              <span className="relative flex h-14 w-14 items-center justify-center rounded-full border-2 border-gold bg-ink/70 text-gold shadow-[0_0_26px_rgba(212,175,55,0.45)] transition-transform duration-300 group-hover:scale-105 sm:h-16 sm:w-16" data-id="element-272" data-mp="1nhvk0rp5hs2q">
                <Play className="ml-0.5 h-6 w-6 fill-gold sm:h-7 sm:w-7" data-id="element-273" data-mp="2z1ixie09dn0" />
              </span>
              <span className="relative font-mono text-[10px] uppercase tracking-[0.18em] text-bone sm:text-[11px]" data-id="element-274" data-mp="7y4or51t7nw1">
                Reproducir la cinta
              </span>
              <span className="relative font-mono text-[8.5px] uppercase tracking-[0.16em] text-white/35" data-id="element-275" data-mp="cq5x4fvuwugs">
                Expediente VDB-2026-014 · Sesión informativa
              </span>
            </button>}
        </div>
      </div>

      <figcaption className="mt-3 text-center font-mono text-[9px] uppercase tracking-[0.16em] text-white/35" data-id="element-276" data-mp="qo49xguj4iu6">
        Sube el volumen · Duración estimada de la sesión informativa
      </figcaption>
    </motion.figure>;
}